import StatTile from "../../StatTile";
import {GeneInfoModalProps} from "../../../types/props";
import ExternalLinks from './ListModalExternalLinks';

import { Card } from 'react-bootstrap';
import React from 'react';

const GeneInfo: React.FC<GeneInfoModalProps> = (
  {
    type,
    name,
    entrezID,
    symbol,
    description,
    uniprot,
    expression,
    expressionScore,
    essentiality,
    fitnessLabel,
    fitnessScore,
    fitnessVariability,
  }) => (
  <div className="col-6 d-flex flex-column">
    <div className="w-100 text-center">
      <div><h6>{type}</h6></div>
      <hr className="my-2" />
      <div><h4>{name}</h4></div>
    </div>

    <div className="mt-2">
      <small className="fst-italic mb-1">HAP1 Gene Expression and Fitness</small>
      <div className="row g-2">
        <StatTile className="col-md-6" title="Gene expression" subtitle="log₂(TPM+1)" label={expression} value={expressionScore}/>
        <StatTile className="col-md-6" title="Gene essentiality" label={essentiality}/>
        <StatTile className="col-md-6" title="Mutant fitness (MF)" subtitle="LFC" label={fitnessLabel} value={fitnessScore}/>
        <StatTile className="col-md-6" title="MF variability" label={fitnessVariability}/>
      </div>
    </div>

    <div className="mt-2">
      <small className="fst-italic mb-1">Gene Description</small>
      <Card body className="gene-description overflow-auto w-100">
        <p className="text-decoration-underline mb-0">{description}</p>
        <p className="mt-0">{uniprot}</p>
      </Card>
    </div>

    <ExternalLinks entrezID={entrezID} symbol={symbol} />
  </div>
);

export default GeneInfo;
